import { useQuery } from '@tanstack/react-query';
import { fetchPortfolioData } from '../infrastructure/portfolio.api';
import type { PortfolioData } from '../domain/portfolio.types';

export const usePortfolioQuery = () => {
  return useQuery<PortfolioData>({
    queryKey: ['portfolio'],
    queryFn: fetchPortfolioData,
    staleTime: Infinity, // The data is local and doesn't change during the session
  });
};
